<template>
    <div class="avatar-wrapper">
        <div class="content">

            <mobile-header>
                <i slot="arrowLeft" class="el-icon-arrow-left" @click="$emit('hideAvatar')"></i> <!-- 旧语法 -->
                <span slot="title" class="text">头像预览</span> <!-- 旧语法 -->
            </mobile-header>

            <img :src="userUrl" alt="">
            <div class="edit-btn">
                编辑头像
            </div>
        </div>

    </div>
</template>

<script>
import MobileHeader from './MobileHeader.vue';
import userUrl from "@/assets/image/user.svg";

export default {
    name: 'avatar',
    components: {
        MobileHeader,
    },
    data() {
        return {
            userUrl
            // data properties
        }
    },
    mounted() {
        // lifecycle hook
    },
    methods: {
        // methods

    }
}
</script>

<style lang="scss" scoped>
.avatar-wrapper {
    /* styles */
    position: absolute;
    top: 0;
    left: 0;
    padding: 0 10px;
    width: calc(100vw - 20px);
    height: 100vh;
    background-color: var(--bg-color-3);
    z-index: 100;
    text-align: center;


    img {
        width: 100%;
    }

    .edit-btn {
        margin: 0 auto;
        margin-top: 30px;
        width: 50%;
        line-height: 3;
        font-size: 14px;
        background-color: $second_blue;
        color: #fff;
        text-align: center;
        border-radius: 60px;
    }

}

@media (min-width: 750px) {
    .content{
        margin: 0 calc((100vw - 750px) / 2);
    }
}
</style>